export default __webpack_public_path__ + "static/media/stripe.166c9620.svg";